import { MouseEvent, useState } from 'react';

import { HELP_URL } from './constants';

export const useAppHeader = () => {
  const [userMenu, setUserMenu] = useState<null | HTMLElement>(null);
  const [showAccoutDialog, setShowAccountDialog] = useState(false);
  const [showResetPasswordDialog, setShowResetPasswordDialog] = useState(false);
  const [showLogoutConfirmDialog, setShowLogoutConfirmDialog] = useState(false);

  // User menu handlers
  const onClickUserMenu = (event: MouseEvent<HTMLElement>) => {
    setUserMenu(event.currentTarget);
  };

  const onCloseUserMenu = () => {
    setUserMenu(null);
  };

  const onCloseAccoutDialog = () => {
    setShowAccountDialog(false);
  };

  const onShowResetPasswordDialog = () => {
    // hide the account dialog then show the reset password dialog
    setShowAccountDialog(false);
    setShowResetPasswordDialog(true);
  };

  const onCloseResetPasswordDialog = () => {
    setShowResetPasswordDialog(false);
  };

  const onShowConfirmLogoutDialog = () => {
    setShowLogoutConfirmDialog(true);
  };

  const onCloseConfirmLogoutDialog = () => {
    setShowLogoutConfirmDialog(false);
  };

  const onClickUserMenuItem = (item: 'accountSetting' | 'help&support' | 'logout') => {
    // close the menu
    setUserMenu(null);

    // handler the different actions based on the item
    switch (item) {
      case 'accountSetting':
        setShowAccountDialog(true);
        break;
      case 'help&support':
        window.location.href = HELP_URL;
        break;
      case 'logout':
        setShowLogoutConfirmDialog(true);
        break;
    }
  };

  // // Applications menu handler
  return {
    userMenu,
    onClickUserMenu,
    onCloseUserMenu,
    onClickUserMenuItem,

    showAccoutDialog,
    onCloseAccoutDialog,

    showResetPasswordDialog,
    onShowResetPasswordDialog,
    onCloseResetPasswordDialog,

    showLogoutConfirmDialog,
    onShowConfirmLogoutDialog,
    onCloseConfirmLogoutDialog,
  };
};
